var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('row',_vm._b({},'row',_vm.bind,false),[_c('label',{staticClass:"grey--text text-body-2",attrs:{"for":"value"}},[_vm._v(_vm._s(_vm.label))]),_c('v-chip',_vm._b({staticClass:"text-uppercase white--text font-weight-bold"},'v-chip',_vm.properties,false),[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }